import { useFormContext } from "react-hook-form";
import { useStyles } from "../styles";
import useJStyles from "$hooks/useJStyles";
import { Button, Text } from "$components";
import { ProjectFormContact } from "./ProjectFormContact";
import { ProjectFormBasicInfo } from "./ProjectFormBasicInfo";
import { useProjectForm } from "../context/ProjectFormContext";
import { ProjectFormAttachments } from "./ProjectFormAttachments";

type Props = {
  onSubmit: any;
  onReset: any;
};

export default function ProjectFormContent({ onSubmit, onReset }: Props) {
  const form = useFormContext();
  const { jclasses } = useJStyles();
  const { errorContainer } = useStyles();

  const { project, currentCompany, isSubmitting, projectError } =
    useProjectForm();

  return (
    <div className={jclasses.jWrapper}>
      <form onSubmit={form.handleSubmit(onSubmit)} className={jclasses.form}>
        <div className={jclasses.formTop}>
          <Text type="h2">
            {project ? "Éditer le projet" : "Ajouter un projet"}
          </Text>
        </div>

        <div className={jclasses.formSectionHead}>
          <Text type="h3">Informations projet</Text>
        </div>

        <ProjectFormBasicInfo />
        <ProjectFormContact />
        {currentCompany && <ProjectFormAttachments />}

        {projectError && <Text className={errorContainer}>{projectError}</Text>}

        <div className={jclasses.footerForm}>
          <Button color="secondary" onClick={onReset}>
            Annuler
          </Button>
          <Button type="submit" disabled={isSubmitting}>
            Enregistrer
          </Button>
        </div>
      </form>
    </div>
  );
}
